import { Component } from '@angular/core';

@Component({
  selector: 'tun-edit-arrow-left-icon',
  templateUrl: './edit-arrow-left-icon.component.html'
})
export class EditArrowLeftIconComponent {
}
